import { useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { Button, Flex, Modal, Radio } from "antd"
import styles from "../../index.module.css"

// Collect Payment and Refund work on one booking at a time, so on an order with several that
// qualify the guide first picks which experience the payment or refund is for.
const ExperiencePickerModal = ({ open, title, options, confirmLabel, onPick, onCancel }) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState(options[0]?.uuid ?? null)

  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered width={420} title={title} destroyOnClose>
      <Flex vertical gap={16} className={styles.modalContent}>
        <Radio.Group value={selected} onChange={(event) => setSelected(event.target.value)}>
          <Flex vertical gap={12}>
            {options.map((option) => (
              <Radio key={option.uuid} value={option.uuid}>
                <Flex vertical gap={2}>
                  <span className={styles.summaryVal}>{option.title}</span>
                  <span className={styles.metaText}>
                    #{option.number} · {option.detail}
                  </span>
                </Flex>
              </Radio>
            ))}
          </Flex>
        </Radio.Group>
        <Flex gap={8} justify="flex-end" className={styles.modalActions}>
          <Button onClick={onCancel}>{t("global.cancel")}</Button>
          <Button type="primary" disabled={!selected} onClick={() => onPick(selected)}>
            {confirmLabel}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

ExperiencePickerModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  // { uuid, title, number (booking number), detail (e.g. "Balance $97.08") }
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      title: PropTypes.string,
      number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      detail: PropTypes.string
    })
  ).isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onPick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default ExperiencePickerModal
